// Jatuh tempo nyata = tanggal invoice + termin (invoice tanpa termin memakai 7 hari)
export const DEFAULT_TERMIN = 7;

export function dueDateOf(invoice) {
  if (!invoice?.invoice_date) return null;
  const d = new Date(invoice.invoice_date);
  if (Number.isNaN(d.getTime())) return null;
  d.setDate(d.getDate() + (invoice.termin_pembayaran || DEFAULT_TERMIN));
  return d;
}

export function dueInfo(invoice) {
  const due = dueDateOf(invoice);
  if (!due) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d0 = new Date(due); d0.setHours(0, 0, 0, 0);
  const sisa = Math.round((d0 - today) / 86400000);
  let color = 'bg-green-100 text-green-700';
  let label = `${sisa} hari lagi`;
  if (sisa < -7) { color = 'bg-red-200 text-red-900'; label = `lewat ${-sisa} hari`; }
  else if (sisa < 0) { color = 'bg-red-100 text-red-700'; label = `lewat ${-sisa} hari`; }
  else if (sisa === 0) { color = 'bg-amber-200 text-amber-900'; label = 'hari ini'; }
  else if (sisa <= 7) { color = 'bg-amber-100 text-amber-800'; }
  return { due, sisa, color, label, dateText: due.toLocaleDateString('id-ID') };
}

export function DueDateCell({ invoice, settled = false }) {
  const info = dueInfo(invoice);
  if (!info) return <span className="text-slate-400 text-xs">-</span>;
  return (
    <div className="text-xs" data-testid={`due-date-${invoice.id}`}>
      <div className="font-mono">{info.dateText}</div>
      {!settled && <span className={`px-1.5 py-0.5 rounded ${info.color}`}>{info.label}</span>}
    </div>
  );
}
